export const DEFAULT_TITLE_TRANSLATE_KEY = "storedDocuments.title";
export const CATEGORY_MANAGEMENT_TITLE_TRANSLATE_KEY = "storedDocuments.categoryManagementTitle";
export const FILE_EDITION_TITLE_TRANSLATE_KEY = "storedDocuments.fileEditionTitle";

export const GENERIC_CATEGORY_LIST_TRANSLATE_BASE = "storedDocuments.genericCategoryList.";
export const SORTING_LIST_TRANSLATE_BASE = "storedDocuments.sortingList.";

export const FILE_OPTIONS_TRANSLATE_BASE = "storedDocuments.documentActions.";
export const FILE_OPTIONS_DOWNLOAD_TRANSLATE_KEY = "download";
export const FILE_OPTIONS_EDIT_TRANSLATE_KEY = "edit";
export const FILE_OPTIONS_DELETE_TRANSLATE_KEY = "delete";

export const FILE_OPTIONS_DOWNLOAD_ICON_CLASSES = "pi pi-download";
export const FILE_OPTIONS_EDIT_ICON_CLASSES = "pi pi-pencil";
export const FILE_OPTIONS_DELETE_ICON_CLASSES = "pi pi-trash";

export const FILE_TYPE_PICTURE_ICON_CLASS = "pi-image";
export const FILE_TYPE_VIDEO_ICON_CLASS = "pi-video";
export const FILE_TYPE_DEFAULT_ICON_CLASS = "pi-file";

export const CREATE_STORED_DOCUMENT_REQUEST_CATEGORY_ID = "categoryId";
export const CREATE_STORED_DOCUMENT_REQUEST_NAME = "fileName";
export const CREATE_STORED_DOCUMENT_REQUEST_FILE = "file";

export const STORED_DOCUMENTS_PATH = "storedDocuments";
export const STORED_DOCUMENT_PATH = "storedDocument";
export const STORED_DOCUMENTS_DOCUMENT_PATH = "document";
export const STORED_DOCUMENTS_CATEGORIES_PATH = "categories";

export const STORED_DOCUMENTS_FORM_NAME = "name";
export const STORED_DOCUMENTS_FORM_CATEGORY_ID = "categoryId";

export const STORED_DOCUMENTS_VIEWCHILD_UPLOAD = "documentUpload";
export const MAX_FILE_SIZE = 5368709120;
export const MAX_FILE_LENGTH = 30;
export const FILE_EXTENSION_REGEX = /\.[^/.]+$/;
